module.exports = __webpack_public_path__ + "img/pingmiantu.4d2df0fc.svg";